import { formatDisplayTitle } from './formatProductTitle';
import { firstProductImage, thumbForGroup } from './catalog/catalogMedia';

export { firstProductImage, thumbForGroup };

/**
 * Build hub tiles (type / subcategory groups) for a category from admin taxonomy + products.
 */
export function buildCategoryGroupCards(meta, productList) {
  const cards = new Map();
  const list = productList || [];

  (meta?.subcategories || []).forEach((s) => {
    const raw = String(s.name || s.slug || '').trim() || s.slug;
    cards.set(s.slug, { key: s.slug, label: formatDisplayTitle(raw), sort: s.sort_order });
  });

  (meta?.types || []).forEach((t) => {
    const ex = cards.get(t.slug);
    const raw = String(t.name || t.slug || '').trim() || t.slug;
    const label = formatDisplayTitle(raw);
    if (ex) {
      cards.set(t.slug, {
        ...ex,
        label,
        sort: Math.min(ex.sort, t.sort_order),
      });
    } else {
      cards.set(t.slug, { key: t.slug, label, sort: t.sort_order });
    }
  });

  list.forEach((p) => {
    const typ = (p.type || '').trim();
    if (typ && !cards.has(typ)) {
      cards.set(typ, {
        key: typ,
        label: formatDisplayTitle(typ.replace(/-/g, ' ')),
        sort: 500 + cards.size,
      });
    }
    const sc = (p.subcategory || '').trim();
    if (sc && !cards.has(sc)) {
      cards.set(sc, {
        key: sc,
        label: formatDisplayTitle(sc.replace(/-/g, ' ')),
        sort: 500 + cards.size,
      });
    }
  });

  return [...cards.values()].sort((a, b) => a.sort - b.sort || a.label.localeCompare(b.label));
}

/** Match hub tiles / list filters: group key is product type OR subcategory (case-insensitive). */
export function productMatchesGroup(product, groupKey) {
  if (!groupKey || String(groupKey).trim().toLowerCase() === 'all') return true;
  const g = String(groupKey).trim().toLowerCase();
  const typ = String(product?.type || '').trim().toLowerCase();
  const sub = String(product?.subcategory || '').trim().toLowerCase();
  return typ === g || sub === g;
}

export function countProductsInGroup(productList, groupKey) {
  const g = String(groupKey || '').trim().toLowerCase();
  if (!g) return 0;
  return (productList || []).filter((p) => productMatchesGroup(p, g)).length;
}
